import { createSlice } from "@reduxjs/toolkit";

/**
 *
 * @type LocationStoreState
 */
const initialState = {
  locationList: { loading: false, data: null, error: null },
  createLocation: { loading: false, data: null, error: null },
  updateLocation: { loading: false, data: null, error: null },
  deleteLocation: { loading: false, data: null, error: null },
};

export const LocationSlice = createSlice({
  name: "location",
  initialState,
  reducers: {
    fetchLocationListRequest: (state, action) => {
      state.locationList.loading = true;
      state.locationList.error = null;
    },
    fetchLocationListSuccess: (state, action) => {
      state.locationList.data = action.payload;
      state.locationList.loading = false;
      state.locationList.error = null;
    },
    fetchLocationListFailure: (state, action) => {
      state.locationList.data = null;
      state.locationList.loading = false;
      state.locationList.error = action.payload;
    },
    createLocationRequest: (state, action) => {
      state.createLocation.loading = true;
      state.createLocation.error = null;
    },
    createLocationSuccess: (state, action) => {
      state.createLocation.data = action.payload;
      state.createLocation.loading = false;
      state.createLocation.error = null;
      state.locationList = addNewLocationSuccess(action.payload, {
        ...state.locationList,
      });
    },
    createLocationFailure: (state, action) => {
      state.createLocation.data = null;
      state.createLocation.loading = false;
      state.createLocation.error = action.payload;
    },
    updateLocationRequest: (state, action) => {
      state.updateLocation.loading = true;
      state.updateLocation.error = null;
    },
    updateLocationSuccess: (state, action) => {
      state.updateLocation.data = action.payload;
      state.updateLocation.loading = false;
      state.updateLocation.error = null;
      state.locationList = updateLocationListSuccess(action.payload, {
        ...state.locationList,
      });
    },
    updateLocationFaliure: (state, action) => {
      state.updateLocation.data = null;
      state.updateLocation.loading = false;
      state.updateLocation.error = action.payload;
    },

    deleteLocationListRequest: (state, action) => {
      state.deleteLocation.loading = true;
      state.deleteLocation.error = null;
    },
    deleteLocationListSuccess: (state, action) => {
      state.deleteLocation.data = action.payload;
      state.deleteLocation.loading = false;
      state.deleteLocation.error = null;
      state.locationList = removeLocation(action.payload, state.locationList);
    },
    deleteLocationListFailure: (state, action) => {
      state.deleteLocation.data = null;
      state.deleteLocation.loading = false;
      state.deleteLocation.error = action.payload;
    },
  },
});

function addNewLocationSuccess(dataToUpdate, state) {
  state.data.data = [...state.data.data, dataToUpdate];
  state.data.total++;
  return state;
}
function updateLocationListSuccess(dataToUpdate, state) {
  state.data.data = state.data.data.map((loc) => {
    if (loc._id !== dataToUpdate._id) return loc;
    return { ...loc, ...dataToUpdate };
  });

  return state;
}

function removeLocation(dataToRemove, state) {
  state.data.data = state.data.data.map((location) => {
    if (location._id !== dataToRemove._id) return location;
    if (!location.length) return location;

    return { ...location, ...dataToRemove };
  });
  return state;
}

export const {
  fetchLocationListRequest,
  fetchLocationListSuccess,
  fetchLocationListFailure,
  createLocationRequest,
  createLocationSuccess,
  createLocationFailure,
  updateLocationRequest,
  updateLocationSuccess,
  updateLocationFaliure,

  deleteLocationListRequest,
  deleteLocationListSuccess,
  deleteLocationListFaliure,
} = LocationSlice.actions;

/**
 *
 * @param {*} state
 * @returns {LocationStoreState['locationList']}
 */
export const getLocationListState = (state) => state.location?.locationList;
export const getLocationCreateState = (store) => store.location?.createLocation;

export default LocationSlice.reducer;
